import { WALLET_MODAL } from '../global-constants.js';
import { getMmdId, setDealerDRLeaseEnabled } from '../helpers/index.js';
import getDRAdminConfig from '../integrations/getDRAdminConfig.js';

// Insert the My Wallet Modal
export const insertWalletModal = async (API, walletScriptHost, config, vehicles) => {
	// Get the site's My Wallet integration configuration
	const { enableLeasePayments, walletTheme } = config;
	let enablePaymentOption = false;

	if (enableLeasePayments) {
		const dealerData = await API.utils.getDealerData();
		const mmdId = getMmdId(vehicles[0], dealerData);
		const drAdminConfig = mmdId ? await getDRAdminConfig(mmdId) : {};
		// dealers with lease enabled
		enablePaymentOption = drAdminConfig?.products?.hasLeasing;
	}

	API.insert('page-footer', async (elem) => {
		const walletModal = document.createElement(WALLET_MODAL);

		// Apply styles here to ensure correct stacking
		walletModal.style.position = 'relative';
		// DDC Sticky Header is 1030
		walletModal.style.zIndex = '1031';

		if (walletTheme) {
			walletModal.setAttribute('theme', walletTheme);
		}
		// to enable payment options buttons on wallet modal
		if (enablePaymentOption) {
			// write to local storage and access it while building payment request in carApi.js
			setDealerDRLeaseEnabled(true); 
			walletModal.setAttribute('data-feature-flags', '{"wallet_payment_option": { "enabled": true }}');
		} else {
			// set false when enableLeasePayments is turned off or DR admin config is updated
			setDealerDRLeaseEnabled(false);
		}

		API.append(elem, walletModal);

		await API.loadJS(`${walletScriptHost}/${WALLET_MODAL}.js`);
	});
}
